import React from "react";
import EventFormPage from "../components/events/EventFormPage";

const EventCreate = () => <EventFormPage mode="create" />;

export default EventCreate;
